import React from "react";
import { useQuery } from "@tanstack/react-query";
import { TriangleAlert } from "lucide-react";
import { api } from "../../lib/api";

export interface HygieneSummary { duplicates: number; emails: number; orders: number; merges_to_check: number; total: number }

export const useHygieneSummary = () => useQuery<HygieneSummary>({ queryKey: ["hygiene-summary"], queryFn: () => api.get("/admin/duplicate-customers/summary").then((r) => r.data), staleTime: 300000, refetchInterval: (q) => ((q.state.data as any)?.refreshing ? 15000 : 300000) });

export interface MergedInfo { primary_email: string | null; secondary_emails: string[]; email_checked: boolean; at?: string; by?: string }

export function SourceTag({ source }: { source: "shopify" | "app" }) {
  return <span className={`mr-2 inline-block border px-1.5 text-[10px] uppercase tracking-widest ${source === "shopify" ? "border-[var(--moss)] text-[var(--moss)]" : "border-border text-neutral-500"}`}>{source}</span>;
}

export function MergedBadge({ merged }: { merged?: MergedInfo | null }) {
  if (!merged) return null;
  const former = merged.secondary_emails.join(", ");
  return (
    <span className="ml-2 inline-flex items-center gap-1 border border-amber-500 bg-amber-50 px-1.5 text-[10px] uppercase tracking-widest text-amber-800" title={former ? `Merged record — former e-mail${merged.secondary_emails.length > 1 ? "s" : ""}: ${former}${merged.email_checked ? "" : " (still to check in Shopify)"}` : "Merged record"} data-testid="merged-badge">
      <TriangleAlert className="h-3 w-3" strokeWidth={1.75} />Merged{former ? ` · was ${former}` : ""}{merged.email_checked ? "" : " · check e-mail"}
    </span>
  );
}
